import { Controller } from "@hotwired/stimulus"

// Troca o favicon pelo ícone do design system quando o serviço não tem o
// ícone do site.
//
// A pista é o tamanho: o globo genérico devolvido para domínios desconhecidos
// vem sempre em 16x16, enquanto ícones reais chegam no tamanho nativo do site
// (28px no GitHub, 32px no Gmail, 64px na Netflix). Comparar por igualdade
// evita o erro anterior — um "menor que 32" descartava o ícone real do GitHub.
const GENERIC_ICON_SIZE = 16

export default class extends Controller {
  static targets = ["image", "fallback"]

  check() {
    const { naturalWidth, naturalHeight } = this.imageTarget
    if (naturalWidth === GENERIC_ICON_SIZE && naturalHeight === GENERIC_ICON_SIZE) this.fallback()
  }

  fallback() {
    this.imageTarget.classList.add("hidden")
    this.fallbackTarget.classList.remove("hidden")
    this.fallbackTarget.classList.add("flex")
  }
}
